// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.completion.LeaseCompletionWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetCompletionStatusResponseDto } from '../..';

interface GetCompletionStatusParams {
  leaseId: number;
}

export const LeaseCompletionWebApiHandler_getCompletionStatus_Path = '/api/web/v1/completion/getCompletionStatus';

/**
 * get the completion status for lease
 */
export const LeaseCompletionWebApiHandler_getCompletionStatus = (
  getParams: GetCompletionStatusParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetCompletionStatusParams, never, GetCompletionStatusResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseCompletionWebApiHandler_getCompletionStatus_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
